/**
 * Utilitaires pour le formatage des données PDF
 */
export const pdfUtils = {
  /**
   * Formate une date pour l'affichage PDF (format français)
   * @param {string} dateString - Date au format ISO ou autre
   * @returns {string} Date formatée (ex: "15/01/2025")
   */
  formatDateForPdf(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR");
  },

  /**
   * Formate un prix en euros - CORRIGÉ selon modèle
   * @param {number} priceInCents - Prix en centimes
   * @returns {string} Prix formaté (ex: "13.47 €") - Point décimal et espace avant €
   */
  formatPrice(priceInCents) {
    if (!priceInCents || priceInCents === 0) return "-";
    return `${(priceInCents / 100).toFixed(2)} €`;
  },

  /**
   * Formate un poids - CORRIGÉ selon modèle
   * @param {string|number} weight - Poids
   * @returns {string} Poids formaté (ex: "25,1kg") - "kg" minuscule
   */
  formatWeight(weight) {
    if (!weight) return "";
    return `${parseFloat(weight).toFixed(1).replace(".", ",")}kg`;
  },

  /**
   * Formate une ration - CORRIGÉ selon modèle
   * @param {string|number} amount - Quantité en grammes
   * @returns {string} Ration formatée (ex: "247g") - "g" minuscule
   */
  formatRation(amount) {
    if (!amount) return "";
    return `${Math.round(parseFloat(amount))}g`;
  },

  /**
   * Calcule la durée d'un sac
   * @param {string|number} dailyAmount - Quantité journalière en grammes
   * @param {string|number} bagWeight - Poids du sac en kg
   * @returns {string} Durée formatée (ex: "52 jours")
   */
  calculateBagDuration(dailyAmount, bagWeight) {
    if (!dailyAmount || !bagWeight) return "";
    const dailyAmountKg = parseFloat(dailyAmount) / 1000;
    const duration = Math.round(parseFloat(bagWeight) / dailyAmountKg);
    return `${duration} jours`;
  },

  /**
   * Formate le nom complet d'un animal et propriétaire
   * @param {string} animalName - Nom de l'animal
   * @param {string} ownerFirstName - Prénom du propriétaire
   * @returns {string} Nom complet (ex: "Spicy Marie")
   */
  formatFullName(animalName, ownerFirstName) {
    if (!animalName || !ownerFirstName) return "";
    return `${animalName} ${ownerFirstName}`;
  },

  /**
   * Formate un numéro de téléphone
   * @param {string} phone - Numéro de téléphone
   * @returns {string} Téléphone formaté (ex: "06.06.06.06.06")
   */
  formatPhone(phone) {
    if (!phone) return "0000000000";
    // Supprime tous les caractères non numériques
    const cleaned = phone.replace(/\D/g, "");
    // Formate en xx.xx.xx.xx.xx
    if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1.$2.$3.$4.$5");
    }
    return phone;
  },

  /**
   * Formate le code SupplyVet
   * @param {string} code - Code SupplyVet
   * @returns {string} Code formaté (ex: "C0001095")
   */
  formatSupplyVetCode(code) {
    if (!code) return "C0000000";
    return code.toUpperCase();
  },

  /**
   * Formate l'adresse complète
   * @param {Object} address - Objet adresse
   * @returns {Object} Adresse formatée
   */
  formatAddress(address) {
    if (!address) return {};

    return {
      street: address.street || "ADRESSE",
      postalCodeCity: `${address.postcode || "00000"} ${address.city || "VILLE"}`.toUpperCase(),
    };
  },

  /**
   * Détermine si le rappel J-7 est activé
   * @param {Array} reminderTypes - Types de rappels activés
   * @returns {string} "Oui" ou "Non"
   */
  formatReminder(reminderTypes) {
    if (!reminderTypes || !Array.isArray(reminderTypes)) return "Non";
    return reminderTypes.length > 0 ? "Oui" : "Non";
  },
};

// Export des fonctions individuelles pour faciliter l'import
export const {
  formatDateForPdf,
  formatPrice,
  formatWeight,
  formatRation,
  calculateBagDuration,
  formatFullName,
  formatPhone,
  formatSupplyVetCode,
  formatAddress,
  formatReminder,
} = pdfUtils;

export default pdfUtils;
